import { useIsMobile } from '@/hooks/use-is-mobile';
import { cn } from '@/lib/utils';
import GalleryAd from '../Gallery/ad';
import GalleryItem from '../Gallery/item';
import NoProductsFound from './NoProductsFound';

export const GalleryContent = ({
  items,
  className,
  // categoryLoading,
  categoryId,
  categoryName,
  advertisements,
  colorFilters,
}: {
  items: any[];
  advertisements: any[];
  className?: string;
  // categoryLoading: boolean;
  categoryId: string;
  categoryName?: string;
  colorFilters: any;
}) => {
  const storeConfig = {
    storeConfig: {
      __typename: 'StoreConfig',
      store_code: process.env.NEXT_PUBLIC_STORE_VIEW_CODE,
      product_url_suffix: '.html',
      magento_wishlist_general_is_enabled: '1',
      base_url: 'https://www.hisea.com/',
    },
  };

  const { isMobile } = useIsMobile();
  // console.log('gallery-content', items);
  // if (items?.length === 0) {
  //   return (
  //     <div className={cn('pt-[20px] lg_pt-[60px]', className)}>
  //       <GalleryShimmer
  //         listColumn={isMobile ? 2 : 4}
  //         items={Array.from({
  //           length: 36,
  //         }).fill(null)}
  //       />
  //     </div>
  //   );
  // }

  if (items?.length === 0) {
    return <NoProductsFound categoryId={categoryId} />;
  }
  const itemsClone = items.concat([]);
  advertisements?.forEach(ad => {
    itemsClone.splice(ad.position - 1, 0, { ...ad, __typename: 'Advertisement' });
  });
  return (
    <div className={cn('grid grid-cols-2 gap-[10px] lg_grid-cols-4 lg_gap-[27px]', className)}>
      {itemsClone.map(item => {
        if (item.__typename === 'Advertisement') {
          return (
            <GalleryAd
              key={item.id}
              item={item}
            />
          );
        }

        return (
          <GalleryItem
            key={item.id}
            item={item}
            colorFilters={colorFilters}
            categoryId={categoryId}
            categoryName={categoryName}
          />
        );
      })}
    </div>
  );
};
